import styles from './ListBox.module.scss';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';

export const ListBox = ({ options, selectedService, setSelectedService }) => {
    console.log(selectedService);
    return (
        <Listbox value={selectedService} onChange={setSelectedService}>
            {({ open }) => (
                <>
                    <ListboxButton className={styles.button}>
                        {selectedService}
                        {
                            open
                                ? <svg width="20" height="20" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M9.14645 28.8536C8.95118 28.6583 8.95118 28.3417 9.14645 28.1464L22.6464 14.6464C22.8417 14.4512 23.1583 14.4512 23.3536 14.6464L36.8536 28.1464C37.0488 28.3417 37.0488 28.6583 36.8536 28.8536C36.6583 29.0488 36.3417 29.0488 36.1464 28.8536L23 15.7071L9.85355 28.8536C9.65829 29.0488 9.34171 29.0488 9.14645 28.8536Z" fill="var(--primary-color)" />
                                </svg>
                                : <svg width="20" height="20" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M36.8536 17.1464C37.0488 17.3417 37.0488 17.6583 36.8536 17.8536L23.3536 31.3536C23.1583 31.5488 22.8417 31.5488 22.6464 31.3536L9.14645 17.8536C8.95119 17.6583 8.95119 17.3417 9.14645 17.1464C9.34171 16.9512 9.65829 16.9512 9.85355 17.1464L23 30.2929L36.1464 17.1464C36.3417 16.9512 36.6583 16.9512 36.8536 17.1464Z" fill="var(--primary-color)" />
                                </svg>
                        }
                    </ListboxButton>
                    <ListboxOptions anchor="bottom" className={styles.options}>
                        {options.map((option, index) => (
                            <ListboxOption
                                key={index}
                                value={option}
                                className={styles.option}
                            >
                                {selectedService === option
                                    ? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20.285 4.715a1 1 0 0 1 0 1.414L9 17.414l-5.285-5.285a1 1 0 1 1 1.414-1.414L9 14.586 18.871 4.715a1 1 0 0 1 1.414 0z" fill="var(--primary-color)" />
                                    </svg>
                                    : <div className={styles.check} />
                                }
                                {option}
                            </ListboxOption>
                        ))}
                    </ListboxOptions>
                </>
            )}
        </Listbox>
    );
};
